export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/take-mealcode' */ './TakeMealCode'
  );
